import React, { useState, useEffect } from "react";
import {
  Modal,
  Backdrop,
  Fade,
  Box,
  Typography,
  Button,
  TextField,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import { Edit } from "@material-ui/icons";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
import serviciosTablero from "utils/serviciosTablero";
import ImageIcon from "@material-ui/icons/Image";
import DescriptionIcon from "@material-ui/icons/Description";
import AddIcon from "@material-ui/icons/Add";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import EditIcon from "@material-ui/icons/Edit";
import { useForm } from "react-hook-form";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4, 6),
    borderRadius: "8px",
    outline: "none",
    width: "600px",
  },
  fileInput: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const Adjunto = ({ open, onClose, tarjeta, setCargando, setMensaje,adjunto, onFileAdded }) => {
  const classes = useStyles();
  const [selectedFile, setSelectedFile] = useState(null);
  const { setValue } = useForm(); // Añadido formState para errores
  const [file, setFile] = useState(null); // Aseguramos que la variable se llama "file"
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile); // Guardamos el archivo en el estado
      setValue("file", selectedFile); // Actualiza el valor en react-hook-form
      const fileUrl = URL.createObjectURL(selectedFile);
      setPreviewUrl(fileUrl);
    }
  };
  const handleClearPreview = () => {
    setFile(null); // Limpia el archivo del estado
    setValue("file", null); // Limpia el valor en react-hook-form
    setPreviewUrl(null);
  };

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("archivo", file); // El archivo
    formData.append("idtarjeta", tarjeta); // ID de la tarjeta
    if (file) {
      serviciosTablero.createFileTarjeta(
        (status, mensaje, response) => {
          if (status == 1) {
            if (response) {
              console.log(response);
              onFileAdded(response); // Enviar archivo creado al callback
            }
            onClose();
            setMensaje({ open: true, status: status, value: mensaje });
          }else{
            setMensaje({ open: true, status: status, value: mensaje });
          }
        },
        setCargando,
        formData
      );
      
    }
  };

  return (
    <Modal
      open={Boolean(open)}
      onClose={onClose}
      className={classes.modal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={Boolean(open)}>
        
        <Box
          className={classes.paper}
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={2}
        >
          <input
            type="file"
            accept="image/*,.pdf"
            onChange={handleFileChange}
            style={{ display: "none" }}
            id="file-input"
          />
          
          <label htmlFor="file-input">
            <Button variant="contained" color="primary" component="span">
              Seleccionar archivo *
            </Button>
          </label>

          {file && ( // Cambiado "selectedFile" por "file"
            <>
              <Typography variant="body1" style={{ color: "white" }}>
                Archivo seleccionado: {file.name}
              </Typography>
              {file.type.startsWith("image/") ? (
                <img
                  src={previewUrl}
                  alt="Vista previa"
                  style={{
                    width: "100%",
                    maxHeight: "400px",
                    marginTop: "10px",
                  }}
                />
              ) : (
                <iframe
                  src={previewUrl}
                  title="Vista previa de PDF"
                  style={{ width: "100%", height: "400px", marginTop: "10px" }}
                />
              )}
              <Grid container justifyContent="center" spacing={2} gap={3}>
                <Grid item>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleClearPreview}
                    style={{ marginTop: "10px" }}
                  >
                    Limpiar selección
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleSubmit}
                    style={{ marginTop: "10px" }}
                  >
                    Subir
                  </Button>
                </Grid>
              </Grid>
            </>
          )}
        </Box>
      </Fade>
    </Modal>
  );
};

export default Adjunto;
